const provinces = require("./province.json");
const webConfigs = require("./configs.js");

const share = {
  statuses: {
    PENDING: "pending",
    PAID: "paid",
    APPROVE: "approved",
    CANCEL: "canceled",
    ACTIVE: "active",
    INACTIVE: "inactive",
    USED: "used",
    EXPIRED: "expired",
    OFFLINE: "offline",
  },
  statusesTranslate: {
    approved: "อนุมัติ",
    pending: "รอชำระเงิน",
    paid: "รออนุมัติ",
    canceled: "ยกเลิก",
    active: "พร้อมใช้งาน",
    inactive: "ปิดใช้งาน",
    used: "ใช้งานแล้ว",
    expired: "หมดอายุ",
    offline: "เปิดใช้งานหลังบ้านเท่านั้น",
  },

  statusColor: {
    approved: "green",
    pending: "yellow",
    paid: "orange",
    canceled: "dangerRed",
    active: "green",
    inactive: "orange",
    used: "blue",
    expired: "red",
    offline: "yellow",
  },

  couponType: {
    DISCOUNT: "discount",
    VOUCHER: "voucher",
    RESERVE: "reserve",
  },

  couponTypeTranslated: {
    discount: "ส่วนลด",
    voucher: "วอยเชอร์",
    reserve: "จองเลขท้าย",
  },

  shippingStatuses: {
    PENDING: "pending",
    PACKING: "packing",
    SHIPPED: "shipped",
    CANCEL: "canceled",
  },
  shippingStatusesTranslate: {
    PENDING: "รอดำเนินการ",
    PACKING: "กำลังเตรียมจัดส่ง",
    SHIPPED: "จัดส่งแล้ว",
    CANCEL: "ยกเลิก",
  },

  deliverChannels: {
    ONLINE: "online",
    MAIL: "mail",
    OFFLINE: "offline",
  },
  paymentChannels: {
    QR: "qr",
    BANK: "bank",
    OFFLINE: "offline",
  },
  stockStatuses: {
    IN_STOCK: "inStock",
    TAKEN: "taken",
  },
  stockStatusesTranslate: {
    IN_STOCK: "อยู่กับบริษัท",
    TAKEN: "ลูกค้ารับแล้ว",
  },
  bankList: [
    { bankName: "ธนาคารกรุงเทพฯ", currency: "THB" },
    { bankName: "ธนาคารไทยพาณิชย์", currency: "THB" },
    { bankName: "ธนาคารกสิกรไทย", currency: "THB" },
    { bankName: "ธนาคารกรุงศรีอยุธยา", currency: "THB" },
    { bankName: "ธนาคารกรุงไทย", currency: "THB" },
    // { bankName: "ธนาคารทหารไทยธนชาต", currency: "THB" },
    { bankName: "ธนาคารทิสโก้", currency: "THB" },
    { bankName: "ธนาคารออมสิน", currency: "THB" },
    { bankName: "ธนาคารอาคารสงเคราะห์", currency: "THB" },
    { bankName: "ธนาคารอิสลามแห่งประเทศไทย", currency: "THB" },
    { bankName: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร", currency: "THB" },
    { bankName: "ธนาคารทหารไทยธนชาต", currency: "THB" },
    { bankName: "ธนาคารซีไอเอ็มบีไทย", currency: "THB" },
    { bankName: "ธนาคารยูโอบี", currency: "THB" },
    { bankName: "ธนาคารแลนด์ แอนด์ เฮ้าส์", currency: "THB" },
    { bankName: "ธนาคารเกียรตินาคินภัทร", currency: "THB" },
    { bankName: "ธนาคารไทยเครดิต", currency: "THB" },
    { bankName: "ธนาคารคลิกซ์", currency: "THB" },
    { bankName: "Joint Development Bank", currency: "LAK" },
    {
      bankName: "Banque Pour Le Commerce Exterieur Lao Public",
      currency: "LAK",
    },

    { bankName: "Lao-Viet Bank Co,Ltd", currency: "LAK" },
    { bankName: "BIC Bank Lao Co., Ltd", currency: "LAK" },
    { bankName: "Lao Development Bank", currency: "LAK" },
    { bankName: "Indochina Bank LTD", currency: "LAK" },
    { bankName: "Maruhan Japan Bank Lao Co.,ltd", currency: "LAK" },
    { bankName: "Agricultural Promotion Bank", currency: "LAK" },
    {
      bankName: "Military Commercial Joint Stock Bank - Laos Branch",
      currency: "LAK",
    },
    { bankName: "KasikornBank in Lao PDR", currency: "LAK" },
    { bankName: "VietinBank Lao limited", currency: "LAK" },
    { bankName: "Acleda Bank Lao Ltd", currency: "LAK" },
    { bankName: "Banque Franco-Lao Ltd", currency: "LAK" },
    { bankName: "Phongsavanh Bank", currency: "LAK" },
    { bankName: "ST Bank LTD", currency: "LAK" },
  ],
};
const resolvedWebConfigs = webConfigs?.default || webConfigs;
export const customerUrl = resolvedWebConfigs?.customerUrl || "https://vandeelucky.com/";

export const getCustomerUrl = (path = "") => {
  const base = (customerUrl || "https://vandeelucky.com/").replace(/\/+$/, "");
  const cleanPath = path ? (path.startsWith("/") ? path : `/${path}`) : "";
  return `${base}${cleanPath}`;
};

export const getAdminOrderUrl = (adminToken) => {
  return `${getCustomerUrl("/orders")}?adminToken=${adminToken}`;
};

const constant = {
  zWspc: "​",
  ...share,
  provinces,
  webConfigs: resolvedWebConfigs,
  getCustomerUrl,
  getAdminOrderUrl,
};

export const transactionsType = {
  WITHDRAW: "withdraw",
  DEPOSIT: "deposit",
  ADDPOINT: "addPoint",
};

export const transactionsTranslate = {
  withdraw: "ถอน",
  deposit: "ฝาก",
  addPoint: "เพิ่มคะแนน",
};

export const statuses = {
  PENDING: "pending",
  PAID: "paid",
  APPROVE: "approved",
  CANCEL: "canceled",
  ACTIVE: "active",
  INACTIVE: "inactive",
  USED: "used",
  EXPIRED: "expired",
  OFFLINE: "offline",
  REMOVED: "removed",
  VERIFIED: "verified",
};

export const banks = [
  "ธนาคารกรุงเทพฯ",
  "ธนาคารไทยพาณิชย์",
  "ธนาคารกสิกรไทย",
  "ธนาคารกรุงศรีอยุธยา",
  "ธนาคารกรุงไทย",
  // "ธนาคารทหารไทยธนชาต",
  "ธนาคารทิสโก้",
  "ธนาคารออมสิน",
  "ธนาคารอาคารสงเคราะห์",
  "ธนาคารอิสลามแห่งประเทศไทย",
  "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
  "ธนาคารทหารไทยธนชาต",
  "ธนาคารซีไอเอ็มบีไทย",
  "ธนาคารยูโอบี",
  "ธนาคารแลนด์ แอนด์ เฮ้าส์",
  "ธนาคารเกียรตินาคินภัทร",
  "Joint Development Bank",
  "Banque Pour Le Commerce Exterieur Lao Public",
  "Lao-Viet Bank Co,Ltd",
  "BIC Bank Lao Co., Ltd",
  "Lao Development Bank",
  "Indochina Bank LTD",
  "Maruhan Japan Bank Lao Co.,ltd",
  "Agricultural Promotion Bank",
  "Military Commercial Joint Stock Bank - Laos Branch",
  "KasikornBank in Lao PDR",
  "VietinBank Lao limited",
  "Acleda Bank Lao Ltd",
  "Banque Franco-Lao Ltd",
  "Phongsavanh Bank",
  "ST Bank LTD",
];

export const productTypeTranslate = {
  richItem: "วัตถุรวยไว",
  premium: "ของพรีเมียม",
  regular: "ของใช้ทั่วไป",
  toy: "ของเล่น",
  beauty: "ความงาม",
  food: "ของกิน",
};

export const countries = [
  { name: "Thailand", code: "TH", nationality: "Thai" },
  { name: "Afghanistan", code: "AF", nationality: "Afghan" },
  { name: "Albania", code: "AL", nationality: "Albanian" },
  { name: "Algeria", code: "DZ", nationality: "Algerian" },
  { name: "Andorra", code: "AD", nationality: "Andorran" },
  { name: "Angola", code: "AO", nationality: "Angolan" },
  { name: "Antigua and Barbuda", code: "AG", nationality: "Antiguan" },
  { name: "Argentina", code: "AR", nationality: "Argentine" },
  { name: "Armenia", code: "AM", nationality: "Armenian" },
  { name: "Australia", code: "AU", nationality: "Australian" },
  { name: "Austria", code: "AT", nationality: "Austrian" },
  { name: "Azerbaijan", code: "AZ", nationality: "Azerbaijani" },
  { name: "Bahamas", code: "BS", nationality: "Bahamian" },
  { name: "Bahrain", code: "BH", nationality: "Bahraini" },
  { name: "Bangladesh", code: "BD", nationality: "Bangladeshi" },
  { name: "Barbados", code: "BB", nationality: "Barbadian" },
  { name: "Belarus", code: "BY", nationality: "Belarusian" },
  { name: "Belgium", code: "BE", nationality: "Belgian" },
  { name: "Belize", code: "BZ", nationality: "Belizean" },
  { name: "Benin", code: "BJ", nationality: "Beninese" },
  { name: "Bhutan", code: "BT", nationality: "Bhutanese" },
  { name: "Bolivia", code: "BO", nationality: "Bolivian" },
  { name: "Bosnia and Herzegovina", code: "BA", nationality: "Bosnian" },
  { name: "Botswana", code: "BW", nationality: "Botswanan" },
  { name: "Brazil", code: "BR", nationality: "Brazilian" },
  { name: "Brunei", code: "BN", nationality: "Bruneian" },
  { name: "Bulgaria", code: "BG", nationality: "Bulgarian" },
  { name: "Burkina Faso", code: "BF", nationality: "Burkinabe" },
  { name: "Burundi", code: "BI", nationality: "Burundian" },
  { name: "Cabo Verde", code: "CV", nationality: "Cape Verdean" },
  { name: "Cambodia", code: "KH", nationality: "Cambodian" },
  { name: "Cameroon", code: "CM", nationality: "Cameroonian" },
  { name: "Canada", code: "CA", nationality: "Canadian" },
  {
    name: "Central African Republic",
    code: "CF",
    nationality: "Central African",
  },
  { name: "Chad", code: "TD", nationality: "Chadian" },
  { name: "Chile", code: "CL", nationality: "Chilean" },
  { name: "China", code: "CN", nationality: "Chinese" },
  { name: "Colombia", code: "CO", nationality: "Colombian" },
  { name: "Comoros", code: "KM", nationality: "Comorian" },
  { name: "Congo (Congo-Brazzaville)", code: "CG", nationality: "Congolese" },
  { name: "Costa Rica", code: "CR", nationality: "Costa Rican" },
  { name: "Croatia", code: "HR", nationality: "Croatian" },
  { name: "Cuba", code: "CU", nationality: "Cuban" },
  { name: "Cyprus", code: "CY", nationality: "Cypriot" },
  { name: "Czechia (Czech Republic)", code: "CZ", nationality: "Czech" },
  { name: "Denmark", code: "DK", nationality: "Danish" },
  { name: "Djibouti", code: "DJ", nationality: "Djiboutian" },
  { name: "Dominica", code: "DM", nationality: "Dominican" },
  { name: "Dominican Republic", code: "DO", nationality: "Dominican" },
  { name: "Ecuador", code: "EC", nationality: "Ecuadorian" },
  { name: "Egypt", code: "EG", nationality: "Egyptian" },
  { name: "El Salvador", code: "SV", nationality: "Salvadoran" },
  { name: "Equatorial Guinea", code: "GQ", nationality: "Equatorial Guinean" },
  { name: "Eritrea", code: "ER", nationality: "Eritrean" },
  { name: "Estonia", code: "EE", nationality: "Estonian" },
  { name: "Eswatini (fmr. Swaziland)", code: "SZ", nationality: "Swazi" },
  { name: "Ethiopia", code: "ET", nationality: "Ethiopian" },
  { name: "Fiji", code: "FJ", nationality: "Fijian" },
  { name: "Finland", code: "FI", nationality: "Finnish" },
  { name: "France", code: "FR", nationality: "French" },
  { name: "Gabon", code: "GA", nationality: "Gabonese" },
  { name: "Gambia", code: "GM", nationality: "Gambian" },
  { name: "Georgia", code: "GE", nationality: "Georgian" },
  { name: "Germany", code: "DE", nationality: "German" },
  { name: "Ghana", code: "GH", nationality: "Ghanaian" },
  { name: "Greece", code: "GR", nationality: "Greek" },
  { name: "Grenada", code: "GD", nationality: "Grenadian" },
  { name: "Guatemala", code: "GT", nationality: "Guatemalan" },
  { name: "Guinea", code: "GN", nationality: "Guinean" },
  { name: "Guinea-Bissau", code: "GW", nationality: "Guinean" },
  { name: "Guyana", code: "GY", nationality: "Guyanese" },
  { name: "Haiti", code: "HT", nationality: "Haitian" },
  { name: "Holy See", code: "VA", nationality: "Vatican" },
  { name: "Honduras", code: "HN", nationality: "Honduran" },
  { name: "Hungary", code: "HU", nationality: "Hungarian" },
  { name: "Iceland", code: "IS", nationality: "Icelandic" },
  { name: "India", code: "IN", nationality: "Indian" },
  { name: "Indonesia", code: "ID", nationality: "Indonesian" },
  { name: "Iran", code: "IR", nationality: "Iranian" },
  { name: "Iraq", code: "IQ", nationality: "Iraqi" },
  { name: "Ireland", code: "IE", nationality: "Irish" },
  { name: "Israel", code: "IL", nationality: "Israeli" },
  { name: "Italy", code: "IT", nationality: "Italian" },
  { name: "Jamaica", code: "JM", nationality: "Jamaican" },
  { name: "Japan", code: "JP", nationality: "Japanese" },
  { name: "Jordan", code: "JO", nationality: "Jordanian" },
  { name: "Kazakhstan", code: "KZ", nationality: "Kazakhstani" },
  { name: "Kenya", code: "KE", nationality: "Kenyan" },
  { name: "Kiribati", code: "KI", nationality: "I-Kiribati" },
  { name: "Kuwait", code: "KW", nationality: "Kuwaiti" },
  { name: "Kyrgyzstan", code: "KG", nationality: "Kyrgyz" },
  { name: "Laos", code: "LAO", nationality: "Laotian" },
  { name: "Latvia", code: "LV", nationality: "Latvian" },
  { name: "Lebanon", code: "LB", nationality: "Lebanese" },
  { name: "Lesotho", code: "LS", nationality: "Basotho" },
  { name: "Liberia", code: "LR", nationality: "Liberian" },
  { name: "Libya", code: "LY", nationality: "Libyan" },
  { name: "Liechtenstein", code: "LI", nationality: "Liechtenstein" },
  { name: "Lithuania", code: "LT", nationality: "Lithuanian" },
  { name: "Luxembourg", code: "LU", nationality: "Luxembourgish" },
  { name: "Madagascar", code: "MG", nationality: "Malagasy" },
  { name: "Malawi", code: "MW", nationality: "Malawian" },
  { name: "Malaysia", code: "MY", nationality: "Malaysian" },
  { name: "Maldives", code: "MV", nationality: "Maldivian" },
  { name: "Mali", code: "ML", nationality: "Malian" },
  { name: "Malta", code: "MT", nationality: "Maltese" },
  { name: "Marshall Islands", code: "MH", nationality: "Marshallese" },
  { name: "Mauritania", code: "MR", nationality: "Mauritanian" },
  { name: "Mauritius", code: "MU", nationality: "Mauritian" },
  { name: "Mexico", code: "MX", nationality: "Mexican" },
  { name: "Micronesia", code: "FM", nationality: "Micronesian" },
  { name: "Moldova", code: "MD", nationality: "Moldovan" },
  { name: "Monaco", code: "MC", nationality: "Monegasque" },
  { name: "Mongolia", code: "MN", nationality: "Mongolian" },
  { name: "Montenegro", code: "ME", nationality: "Montenegrin" },
  { name: "Morocco", code: "MA", nationality: "Moroccan" },
  { name: "Mozambique", code: "MZ", nationality: "Mozambican" },
  { name: "Myanmar", code: "MM", nationality: "Burmese" },
  { name: "Namibia", code: "NA", nationality: "Namibian" },
  { name: "Nauru", code: "NR", nationality: "Nauruan" },
  { name: "Nepal", code: "NP", nationality: "Nepali" },
  { name: "Netherlands", code: "NL", nationality: "Dutch" },
  { name: "New Zealand", code: "NZ", nationality: "New Zealander" },
  { name: "Nicaragua", code: "NI", nationality: "Nicaraguan" },
  { name: "Niger", code: "NE", nationality: "Nigerien" },
  { name: "Nigeria", code: "NG", nationality: "Nigerian" },
  { name: "North Korea", code: "KP", nationality: "North Korean" },
  { name: "North Macedonia", code: "MK", nationality: "Macedonian" },
  { name: "Norway", code: "NO", nationality: "Norwegian" },
  { name: "Oman", code: "OM", nationality: "Omani" },
  { name: "Pakistan", code: "PK", nationality: "Pakistani" },
  { name: "Palau", code: "PW", nationality: "Palauan" },
  { name: "Palestine State", code: "PS", nationality: "Palestinian" },
  { name: "Panama", code: "PA", nationality: "Panamanian" },
  { name: "Papua New Guinea", code: "PG", nationality: "Papua New Guinean" },
  { name: "Paraguay", code: "PY", nationality: "Paraguayan" },
  { name: "Peru", code: "PE", nationality: "Peruvian" },
  { name: "Philippines", code: "PH", nationality: "Filipino" },
  { name: "Poland", code: "PL", nationality: "Polish" },
  { name: "Portugal", code: "PT", nationality: "Portuguese" },
  { name: "Qatar", code: "QA", nationality: "Qatari" },
  { name: "Romania", code: "RO", nationality: "Romanian" },
  { name: "Russia", code: "RU", nationality: "Russian" },
  { name: "Rwanda", code: "RW", nationality: "Rwandan" },
  { name: "Saint Kitts and Nevis", code: "KN", nationality: "Kittitian" },
  { name: "Saint Lucia", code: "LC", nationality: "Saint Lucian" },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    nationality: "Vincentian",
  },
  { name: "Samoa", code: "WS", nationality: "Samoan" },
  { name: "San Marino", code: "SM", nationality: "Sammarinese" },
  { name: "Sao Tome and Principe", code: "ST", nationality: "Sao Tomean" },
  { name: "Saudi Arabia", code: "SA", nationality: "Saudi" },
  { name: "Senegal", code: "SN", nationality: "Senegalese" },
  { name: "Serbia", code: "RS", nationality: "Serbian" },
  { name: "Seychelles", code: "SC", nationality: "Seychellois" },
  { name: "Sierra Leone", code: "SL", nationality: "Sierra Leonean" },
  { name: "Singapore", code: "SG", nationality: "Singaporean" },
  { name: "Slovakia", code: "SK", nationality: "Slovak" },
  { name: "Slovenia", code: "SI", nationality: "Slovenian" },
  { name: "Solomon Islands", code: "SB", nationality: "Solomon Islander" },
  { name: "Somalia", code: "SO", nationality: "Somali" },
  { name: "South Africa", code: "ZA", nationality: "South African" },
  { name: "South Korea", code: "KR", nationality: "South Korean" },
  { name: "South Sudan", code: "SS", nationality: "South Sudanese" },
  { name: "Spain", code: "ES", nationality: "Spanish" },
  { name: "Sri Lanka", code: "LK", nationality: "Sri Lankan" },
  { name: "Sudan", code: "SD", nationality: "Sudanese" },
  { name: "Suriname", code: "SR", nationality: "Surinamese" },
  { name: "Sweden", code: "SE", nationality: "Swedish" },
  { name: "Switzerland", code: "CH", nationality: "Swiss" },
  { name: "Syria", code: "SY", nationality: "Syrian" },
  { name: "Tajikistan", code: "TJ", nationality: "Tajik" },
  { name: "Tanzania", code: "TZ", nationality: "Tanzanian" },
  { name: "Thailand", code: "TH", nationality: "Thai" },
  { name: "Timor-Leste", code: "TL", nationality: "Timorese" },
  { name: "Togo", code: "TG", nationality: "Togolese" },
  { name: "Tonga", code: "TO", nationality: "Tongan" },
  { name: "Trinidad and Tobago", code: "TT", nationality: "Trinidadian" },
  { name: "Tunisia", code: "TN", nationality: "Tunisian" },
  { name: "Turkey", code: "TR", nationality: "Turkish" },
  { name: "Turkmenistan", code: "TM", nationality: "Turkmen" },
  { name: "Tuvalu", code: "TV", nationality: "Tuvaluan" },
  { name: "Uganda", code: "UG", nationality: "Ugandan" },
  { name: "Ukraine", code: "UA", nationality: "Ukrainian" },
  { name: "United Arab Emirates", code: "AE", nationality: "Emirati" },
  { name: "United Kingdom", code: "GB", nationality: "British" },
  { name: "United States of America", code: "US", nationality: "American" },
  { name: "Uruguay", code: "UY", nationality: "Uruguayan" },
  { name: "Uzbekistan", code: "UZ", nationality: "Uzbek" },
  { name: "Vanuatu", code: "VU", nationality: "Ni-Vanuatu" },
  { name: "Venezuela", code: "VE", nationality: "Venezuelan" },
  { name: "Vietnam", code: "VN", nationality: "Vietnamese" },
  { name: "Yemen", code: "YE", nationality: "Yemeni" },
  { name: "Zambia", code: "ZM", nationality: "Zambian" },
  { name: "Zimbabwe", code: "ZW", nationality: "Zimbabwean" },
];
export default constant;
